import { StyleSheet, Platform } from 'react-native';

export default StyleSheet.create({
  modalContent: {
    paddingTop: Platform.OS === 'ios' ? 34 : 32,
  },
  modalHeader: {
    marginHorizontal: 0,
  },
  modalIconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 53,
  },
  iconContainer: {
    height: 125,
    width: 125,
  },
  modalMessage: {
    alignSelf: 'center',
    marginTop: 33,
    fontSize: Platform.OS === 'ios' ? 25 : 24.4,
    fontWeight: 'bold',
  },
  modalDescription: {
    alignSelf: 'center',
    marginTop: 20,
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
  },
  modalButton: {
    marginTop: 66,
  },
  modalButtonText: {
    fontSize: Platform.OS === 'ios' ? 18.6 : 18,
  },
});
